import { translations } from "../translations";
import SectionHeading from "./SectionHeading";

export default function MissionStatement() {
  const t = translations;

  return (
    <SectionHeading greenText={t.missionGreen} maxWidth="1100px">
      {t.missionText} <br /> {t.missionEnd}
    </SectionHeading>
  );
}
